module.exports = __webpack_public_path__ + "img/GLRefrigeracao.3325cb2a.png";